import React from "react";
import { connect } from "react-redux";
import { Form, Col, Row, Badge } from "react-bootstrap";
import PropTypes from "prop-types";

import ConditionalButton from "../../../layout/conditional-button"
import DeleteModal from "../../../layout/modal";

import { withNavigation } from "../../../utils/wrapper";

import { send as pageInfo, loading } from "../../../actions/page";
import { get, save, destroy } from "../../../actions/surveys";

class Settings extends React.Component {
    
    constructor(props) {
        super(props);
        this.props.loading(true);
        this.state = {
            name: "",
            description: "",
            hidden: false,
            uuid: "undefined",
            ...props,
            changed: false,
            modal: {
                delete: {
                    show: false
                }
            }
        };
        this.props.pageInfo({ title: "Survey Information", breadcrumb: this.state?.name });
        this.errors = {};

    }

    get uuid() {
        return this.props.params.uuid;
    }

    loadData = async () => {
        this.props.loading(true);
        const item = await this.props.get({ uuid: this.props.params.uuid });

        this.setState({
            ...item
        })

        this.props.pageInfo({ title: `Survey Information (${item.key})`, breadcrumb: item?.name });
        this.props.loading(false);
    }
    
    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 100);
    }

    onSaveClick = async (e) => {
        const values = { ...this.state };
        const result = await this.props.save({ ...values });
        window.location.href = `/dashboard/settings/surveys/${result.uuid}`;
    }

    onDeleteClick = (e) => {
        this.setState({
            ...this.state,
            modal: {
                ...this.state.modal,
                delete: {
                    title: "Delete Survey",
                    body: `This action will permanently delete the survey named ${this.state.name}. If this survey has unprocessed results (in part or whole), those results will be lost.`,
                    show: true
                }
            }
        });
    }
    
    
    onDeleteOkModal = (e) => {
        this.props.destroy(this.state.uuid);
        this.onDeleteHideModal(e);
        this.props.navigate("/dashboard/settings/surveys");
    }
    
    onDeleteHideModal = (e) => {
        this.setState(prev => ({
            modal: {
                ...prev.modal,
                delete: {
                    show: false
                }
            }
        }));
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        })
    }

    onSystemChange = (e) => {
        this.setState({
            ...this.state,
            system: {
                ...this.state.system,
                [e.target.name]: e.target.value
            }
        })
    }

    onCheckChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.checked
        })
    }

    onFlagsFormat = (e) => {
        const flags = Number(e) | 0;
        const defs = [
            [1, "people", "dark"],
            [2, "leads", "dark"],
            [4, "clients", "dark"],
            [8, "attorneys", "dark"],
            [16, "judges", "dark"],
            [32, "staff", "dark"],
            [65536, "profile", "secondary"],
            [131072, "lead", "secondary"],
            [262144, "client", "secondary"],
            [524288, "attorney", "secondary"],
            [1048576, "judge", "secondary"],
            [2097152, "staff", "secondary"],
            [4194304, "divorce", "secondary"],
            [8388608, "custody", "secondary"],
            [16777216, "support", "secondary"],
            [33554432, "civil", "secondary"],
            [67108864, "name change", "secondary"],
        ];
        return (
            <>
                {defs
                    .filter(([mask]) => (flags & mask) !== 0)
                    .map(([, label, bg], i) => (
                        <Badge key={i} pill bg={bg} className="me-1">
                            {label}
                        </Badge>
                    ))}
            </>)
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Save Configuration" display={true} enabled={true} onEnabledClick={this.onSaveClick} icon="save">Save</ConditionalButton>
                    <ConditionalButton enabledVariant="outline-danger" tooltip="Delete configuration" display={true} enabled={true} onEnabledClick={this.onDeleteClick} icon="bin">Delete</ConditionalButton>
                </Col>
                
                <Col xs="12">
                    <Row>
                        <Col lg="12">
                            <Row className="g-3">
                                <Col lg="12">
                                    <h2 className="small-title">Matter's System Display</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" lg="8">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="name" value={this.state.name || ""} onChange={this.onChange} />
                                        <Form.Label>CAPTION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12" lg="4">
                                    <div className="mb-3">
                                        <Form.Check onChange={(e) => this.onCheckChange(e)} type="switch" checked={this.state.hidden} name="hidden" label="Hidden?" />
                                    </div>
                                </Col>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="description" value={this.state.description || ""} onChange={this.onChange} />
                                        <Form.Label>DESCRIPTION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12">
                                    { this.onFlagsFormat(this.state.flags)}
                                </Col>
                                
                               
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col lg="12">
                            <Row className="g-3">
                                <Col lg="12">
                                    <h2 className="small-title">Survey Display</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="name" value={this.state.system?.name || ""} onChange={this.onSystemChange} />
                                        <Form.Label>CAPTION</Form.Label>
                                    </div>
                                </Col>
                                <Col xs="12">
                                    <div className="mb-3 top-label">
                                        <Form.Control type="text" name="description" value={this.state.system?.description || ""} onChange={this.onSystemChange} />
                                        <Form.Label>DESCRIPTION</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <DeleteModal show={this.state.modal.delete.show} title={this.state.modal.delete.title} body={this.state.modal.delete.body} buttons={
                    [
                        {
                            caption: "ok",
                            onEnabledClick: this.onDeleteOkModal,
                            variant: "primary",
                            enabled: true,
                            display: true
                        },
                        {
                            default: true,
                            caption: "cancel",
                            onEnabledClick: this.onDeleteHideModal,
                            variant: "secondary",
                            enabled: true,
                            display: true
                        }
                    ]
                }></DeleteModal>
            </>
    )}
}

Settings.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { pageInfo, loading, get, save, destroy })(Settings));
